// extracted by mini-css-extract-plugin
export default {"modalRoot":"ModalLayout_modalRoot__stHJH","title":"ModalLayout_title__+gHMa","subtitle":"ModalLayout_subtitle__8LM0z"};